import React from "react";
import {Typography, Link} from "@material-ui/core";
import {makeStyles} from "@material-ui/core";
import {useI18N} from "../../../common/common";
import clsx from "clsx";
import * as ROUTES from "../../../common/routes";
import Grid from "@material-ui/core/Grid";
import {useBreakpoints} from "../../../hooks";

const useStyles = makeStyles((theme) => ({
    marginTop: {
        marginTop: theme.spacing(3)
    },
    symbol: {
        maxWidth: "3% !important",
        flexBasis: "3% !important"
    },
    symbolMobile: {
        maxWidth: "4% !important",
        flexBasis: "4% !important"
    },
}));

const TermsConditions = () => {

    const classes = useStyles();
    const {i18n} = useI18N();
    const {isExtraSmallScreen} = useBreakpoints();

    const getHyperLink = (str) => {
        return (
            <Link
                key={str}
                href={ROUTES.IMPRINT + "/general-terms-and-conditions/"}
                target="_blank"
                rel="noopener noreferrer"
            >
                {str}
            </Link>
        );
    };

    return (
        <Grid container>
            <Grid
                item
                xs={1}
                className={clsx(
                    classes.marginTop,
                    classes.symbol,
                    {[classes.symbolMobile]: isExtraSmallScreen()}
                )}
            >
                <Typography
                    variant="body2"
                    color="textSecondary"
                >
                    {"*"}
                </Typography>
            </Grid>

            <Grid
                item
                xs={11}
            >
                <Typography
                    variant="body2"
                    color="textSecondary"
                    className={clsx(classes.marginTop)}
                >
                    {i18n("view.marketplace.offer_details.your_shares_are_transferred", {hyperlink: getHyperLink})}
                </Typography>

            </Grid>

        </Grid>
    );
};

TermsConditions.propTypes = {};

export default TermsConditions;
